import { render, staticRenderFns } from "./GraphView.vue?vue&type=template&id=2080a580&scoped=true"
import script from "./GraphView.vue?vue&type=script&lang=js"
export * from "./GraphView.vue?vue&type=script&lang=js"
import style0 from "./GraphView.vue?vue&type=style&index=0&id=2080a580&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080a580",
  null
  
)

export default component.exports